import { List, ListItem, SwipeableDrawer, styled } from "@mui/material";

import { DefaultUrlWeb } from "config/Configuration";

export function CoinSingleDrawer({ onClose, open, onCoinClick, coinList }) {
  const handleItemClick = (coin) => {
    onCoinClick(coin);

    onClose();
  };

  return (
    <SwipeableDrawer anchor="left" open={open} onClose={onClose}>
      <List>
        {coinList?.map((coin, index) => (
          <ListItemStyle key={index} onClick={() => handleItemClick(coin)}>
            <img
              src={DefaultUrlWeb + coin?.coinImageUrl}
              alt={coin?.coinName}
            />
            {coin.coinName}
          </ListItemStyle>
        ))}
      </List>
    </SwipeableDrawer>
  );
}

const ListItemStyle = styled(ListItem)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  paddingTop: theme.spacing(1.25),
  paddingBottom: theme.spacing(1.25),
  fontSize: "16px",
  fontWeight: "400",
  color: theme.palette.text.main,
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  paddingLeft: theme.spacing(0.6),
  minWidth: "210px",

  img: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    objectFit: "contain",
    marginRight: "15px",
    backgroundColor: theme.palette.grey[30],
    padding: theme.spacing(0.6),
  },
}));

export default CoinSingleDrawer;
